// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1AJML","fileBtn":"File_fileBtn__18V8d","closeBtn":"File_closeBtn__2yJQZ","fileSelected":"File_fileSelected__oWP4F","disabled":"File_disabled__2GbQ9"};